import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, CalendarClock, MessageSquare, User, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function MobileNav() {
  const loc = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const dash = user ? (user.role === "customer" ? "/dashboard" : user.role === "driver" ? "/driver" : ["admin", "super_admin"].includes(user.role) ? "/admin" : "/agent") : "/login";

  const items = [
    { icon: Home, label: "Home", to: "/" },
    { icon: CalendarClock, label: "Bookings", to: dash },
    { icon: MessageSquare, label: "Messages", to: user ? "/messages" : "/login" },
    { icon: User, label: "Profile", to: user ? dash : "/login" },
  ];

  return (
    <>
      <button
        onClick={() => navigate("/search")}
        data-testid="mobile-book-fab"
        className="fixed bottom-20 right-4 z-40 flex items-center gap-2 rounded-full bg-brand px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-brand/30 lg:hidden"
      >
        <Plus size={18} /> Book Taxi
      </button>
      <nav className="fixed bottom-0 left-0 z-40 w-full border-t border-slate-200 bg-white/95 backdrop-blur-md lg:hidden">
        <div className="grid grid-cols-4">
          {items.map((it) => {
            const active = loc.pathname === it.to;
            return (
              <Link key={it.label} to={it.to} data-testid={`mobilenav-${it.label.toLowerCase()}`}
                className={`flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium ${active ? "text-brand" : "text-slate-500"}`}>
                <it.icon size={20} /> {it.label}
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
